import React, {useContext} from 'react';
import {Card, CardBody, Row, Col, Button} from 'reactstrap';
import * as R from 'ramda';
import {useTranslation} from 'react-i18next';
import useAPI from '@/hooks/useAPI';
import Form, {Text, Select, RadioGroup, DatePicker} from '@/Form';

import styles from '@/b2b/index.module.css';
import {PopError} from '@/b2b/components/Pop';

import {srFollowupType} from '@/b2b/apis';
import {ServiceRecordCtx} from '@/b2b/contexts';
import {initialFields} from '@/b2b/pages/ServiceRecord/state';

import {
  buildRadioOptions,
  buildSelectOptions,
} from '@/components/Form/formHelper';

const SearchBox = () => {
  const {t: tr} = useTranslation();
  const [{fields, queryParams}, dispatch] = useContext(ServiceRecordCtx);

  const formData = {
    ...fields,
    manager: queryParams.manager,
    selectedProducerId: queryParams.selectedProducerId,
  };

  const handleReset = () => {
    dispatch({type: 'changeFields', payload: initialFields});
  };

  const setFormData = callback => {
    dispatch({type: 'changeFields', payload: callback()});
  };

  const handleSubmit = event => {
    event.preventDefault();
    dispatch({type: 'submit'});
  };

  const {result, error} = useAPI(srFollowupType);

  const allFollowupType = R.compose(
    R.map(item => [item.value, item.type]),
    R.prepend({value: '', type: tr('sr:sr_all')}),
    R.pathOr([], ['data'])
  )(result);

  if (error) {
    return <PopError error={String(error)} />;
  }

  return (
    <Form
      className={styles.search_box}
      stateHook={[formData, setFormData]}
      onSubmit={handleSubmit}
    >
      <Card>
        <CardBody className={styles.search_box_body}>
          <Row form>
            <Col md={10}>
              <Text name='manager' label={tr('consultant')} readOnly />
            </Col>
            <Col md={2}>
              <RadioGroup name='includedTeam' label={tr('included_team')}>
                {buildRadioOptions(
                  tr('selection:included_team'),
                  formData.includedTeam
                )}
              </RadioGroup>
            </Col>
          </Row>
          <Row form>
            <Col md={3}>
              <Text name='keywords' label={tr('sr:keywords')} />
            </Col>
            <Col md={{size: 3, offset: 1}}>
              <label>{tr('sr:sr_status')}</label>
              <Row>
                <Select name='statusOptions'>
                  {buildSelectOptions(tr('selection:status_options'))}
                </Select>
              </Row>
            </Col>
            <Col md={5}>
              <label>{tr('sr:sr_type')}</label>
              <Row>
                <Select name='typeOptions'>
                  {buildSelectOptions(allFollowupType)}
                </Select>
              </Row>
            </Col>
          </Row>
          <Row form>
            <Col md={5}>
              <label>{tr('search_create_date')}</label>
              <Row>
                <Col md={4} className='pr-1'>
                  <DatePicker name='createdFrom' />
                </Col>
                <Col md={4} className='pr-1'>
                  <DatePicker name='createdTo' />
                </Col>
              </Row>
            </Col>
            <Col md={5}>
              <label>{tr('search_complete_date')}</label>
              <Row>
                <Col md={4} className='pr-1'>
                  <DatePicker name='completedFrom' />
                </Col>
                <Col md={4} className='pr-1'>
                  <DatePicker name='completedTo' />
                </Col>
              </Row>
            </Col>
          </Row>
          <Row form>
            <Col md={10} />
            <Col md='1 text-right'>
              <Button size='sm' type='submit'>
                {tr('search')}
              </Button>
            </Col>
            <Col md={1}>
              <Button size='sm' onClick={handleReset} color='secondary'>
                {tr('reset')}
              </Button>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Form>
  );
};

export default SearchBox;
